import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import router from './router'
import store from './store'
import './plugins/base'
import axios from 'axios'
import 'viewerjs/dist/viewer.css'
import Viewer from 'v-viewer'
Vue.use(Viewer)
import OtpInput from "@bachdgvn/vue-otp-input";
Vue.component("v-otp-input", OtpInput);
import ImageMagnifier from 'vue-image-magnifier'
Vue.use(ImageMagnifier)

// import VueCropper from 'vue-cropperjs';
// import 'cropperjs/dist/cropper.css';
// import 'vue-advanced-cropper/dist/style.css';

// Vue.component(VueCropper);
// import VueTelInput from 'vue-tel-input'
// Vue.use(VueTelInput)
import VueApexCharts from 'vue-apexcharts'
Vue.use(VueApexCharts)

import JsonExcel from "vue-json-excel";
Vue.component("downloadExcel", JsonExcel);

Vue.component('apexchart', VueApexCharts)
import VueElementLoading from 'vue-element-loading'
Vue.component('VueElementLoading', VueElementLoading)

import ServerError from './views/pages/page500'
Vue.component('ServerError', ServerError)

Vue.config.productionTip = false

Window.axios = require('axios');
// Vue.use(axios)
// Vue.prototype.baseURL = "http://13.235.133.41/u/";
Vue.prototype.baseURL = "https://api.woopgo.com/wp/"
axios.defaults.baseURL = "https://api.woopgo.com";
// Vue.prototype.baseURL = "http://13.232.188.153/wp/"
Vue.prototype.ipURL = "https://api.woopgo.com";
Vue.prototype.jsonURL = "https://api.woopgo.com/json/";
Vue.prototype.appColor= '#3696E0'

new Vue({
    vuetify,
    store,
    router,
    render: h => h(App)
}).$mount('#app')